import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { successSchema } from '../../utils';
import {
  ZPlayerPreferencesEmailSelect,
  ZPlayerPreferencesEmailSettings,
} from './models';

const c = initContract();
export const authPlayerPreferencesContract = c.router(
  {
    getEmailPreferences: {
      method: 'GET',
      path: '/emails',
      responses: {
        200: ZPlayerPreferencesEmailSelect,
        404: c.type<{ message: 'Not Found'; reason: string }>(),
      },
      summary: 'Get player preferences for emails contract',
    },
    setEmailPreferences: {
      method: 'POST',
      path: '/emails',
      body: ZPlayerPreferencesEmailSettings,
      responses: {
        200: successSchema,
        400: z.object({
          message: z.string(),
        }),
      },
      summary: 'Set player preferences for emails contract',
    },
  },
  {
    pathPrefix: '/auth',
    baseHeaders: z.object({
      'x-access-token': z.string(),
    }),
    commonResponses: {
      401: c.type<{ message: 'Unauthorized'; statusCode: 401 }>(),
    },
  },
);
